module.exports = __webpack_public_path__ + "img/023-anchor.7eb03d0a.svg";